$(() => {
	$(document).ready(function () {
		$('.nav-button').click(function () {
			$('html').toggleClass('nav-open');
		});
	});
});



// WEBPACK FOOTER //
// ./assets/scripts/menu.js